import { EventHandler } from "./EventTypes";
import { GlobalEventBus } from "./GlobalEventBus";
import { ModuleEventBus } from "./ModuleEventBus";

export class EventBus {
  private modules: Map<string, ModuleEventBus> = new Map();
  private globalBus: GlobalEventBus = new GlobalEventBus();

  registerModule(name: string): ModuleEventBus {
    const existing = this.modules.get(name);
    if (existing) return existing;
    const moduleBus = new ModuleEventBus(name, this.globalBus);
    this.modules.set(name, moduleBus);
    return moduleBus;
  }

  getModuleBus(name: string): ModuleEventBus | undefined {
    return this.modules.get(name);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emitGlobal(event: string, payload: any): void {
    this.globalBus.emit(event, payload);
  }

  subscribeGlobal(event: string, handler: EventHandler): string {
    return this.globalBus.subscribe(event, handler);
  }

  enableDebug(): void {
    this.globalBus.enableDebug();
  }
}

// Global event bus instance
export const eventBus = new EventBus();

/**
 * Register all domain modules with the EventBus.
 * Call once during app initialization to ensure all modules are registered
 * before any component tries to use them.
 */
export function registerDomainModules(): void {
  const domains = ["auth", "organization", "project", "application", "user"];
  for (const domain of domains) {
    eventBus.registerModule(domain);
  }
}
